/* eslint-disable no-shadow */
/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { detect } from "detect-browser";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  loadActivityFeed,
  loadMorePosts,
} from "../../actions/activityFeedActions";
import ErrorBoundary from "../shared/error/ErrorBoundary";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import ActivityFeedPost from "./ActivityFeedPost";
import MiniSpinner from "../shared/loaders/MiniSpinner";
import {
  Wrapper,
  Header,
  Title,
  BetaBadge,
  FeedWrapper,
  Loaded,
  Error,
  NoPosts,
} from "./styles/activity-feed-styles";

export class Desktop extends Component {
  componentDidMount() {
    const { loadActivityFeed } = this.props;
    loadActivityFeed();
  }

  render() {
    const {
      posts,
      errors,
      loadMorePosts,
      loading,
      page,
      hasMore,
      isPortalUser,
    } = this.props;

    const isIE = detect().name === "ie";

    return (
      <Wrapper id="activity-feed" isIE={isIE}>
        <ErrorBoundary>
          {loading ? (
            <WidgetLoading />
          ) : (
            <Fragment>
              <Header>
                <Title>
                  {isPortalUser && "marketplace "} activity feed
                  <BetaBadge>new!</BetaBadge>
                </Title>
              </Header>
              <FeedWrapper ref={this.feedWrapper} id="feed-wrapper" isIE={isIE}>
                {errors && <Error>Error occurred</Error>}
                {posts.length < 1 && <NoPosts />}
                <InfiniteScroll
                  dataLength={posts.length}
                  next={() => loadMorePosts(page)}
                  hasMore={hasMore}
                  scrollableTarget="feed-wrapper"
                  loader={
                    <MiniSpinner
                      size={20}
                      absolute
                      top={12}
                      right={20}
                      mobileTop={11}
                      mobileRight={50}
                    />
                  }
                  endMessage={
                    <Loaded>
                      <span role="img" aria-label="confetti emoji">
                        🎉
                      </span>{" "}
                      Yay! You have seen it all.
                    </Loaded>
                  }
                >
                  {posts.map((post) => (
                    <ActivityFeedPost key={post.id} post={post} />
                  ))}
                </InfiniteScroll>
              </FeedWrapper>
            </Fragment>
          )}
        </ErrorBoundary>
      </Wrapper>
    );
  }
}

Desktop.propTypes = {
  loadActivityFeed: PropTypes.func.isRequired,
  loadMorePosts: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  hasMore: PropTypes.bool.isRequired,
  page: PropTypes.number,
  posts: PropTypes.arrayOf(PropTypes.shape({})),
  errors: PropTypes.shape({}),
  isPortalUser: PropTypes.bool.isRequired,
};

Desktop.defaultProps = {
  posts: PropTypes.isNull,
  errors: PropTypes.isNull,
  page: PropTypes.number.isNull,
};

const mapStateToProps = (state) => ({
  loading: state.activityFeed.loading,
  posts: state.activityFeed.posts,
  page: state.activityFeed.page,
  hasMore: state.activityFeed.hasMore,
  isPortalUser: state.activityFeed.isPortalUser,
});

export default connect(mapStateToProps, { loadActivityFeed, loadMorePosts })(
  Desktop
);
